export const defaultStoreSettings = {
    defaultDevelopmentPhase: 2,
}